export function timeAgo(ts: number, now = Date.now()): string {
  const s = Math.round((now - ts) / 1000);
  if (s < 45) return "just now";
  const m = Math.round(s / 60);
  if (m < 60) return `${m}m ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h}h ago`;
  const d = Math.round(h / 24);
  if (d < 7) return `${d}d ago`;
  return new Date(ts).toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

export function greeting(date = new Date()): string {
  const h = date.getHours();
  if (h < 12) return "Good morning";
  if (h < 17) return "Good afternoon";
  return "Good evening";
}

export function plural(n: number, word: string, pluralWord = `${word}s`): string {
  return `${n.toLocaleString()} ${n === 1 ? word : pluralWord}`;
}

export function dollars(n: number): string {
  return `$${n.toFixed(2)}`;
}

export const REPEAT_LABELS: Record<string, string> = {
  once: "One time",
  daily: "Daily",
  weekly: "Weekly",
  anytime: "Any time",
};

export const KIND_LABELS: Record<string, string> = {
  cash: "Cash",
  time: "Time",
  item: "Item",
  digital: "Digital",
  privilege: "Privilege",
  experience: "Experience",
};

export const LEDGER_LABELS: Record<string, string> = {
  job: "Job",
  bonus: "Bonus",
  deduction: "Deduction",
  redemption: "Spent",
  refund: "Refund",
  adjustment: "Adjustment",
  recovery: "Worked it off",
};
